<ng-container *ngFor="let item of items; trackBy: trackItems">
  <u-icon
    *ngIf="item && !item?.component && !item?.hideIcon"
    [pTooltip]="(showShortcut$ | async) ? '' : item.toolTipText + '&#13; &#13;' + (item.keyBinding ? (item.keyBinding | keyIcon) : '')"
    [escape]="false"
    tooltipPosition="top"
    [attr.data-cy]="'action-icon-' + item.id"
    tooltipStyleClass="u-tooltip"
    (click)="onAction.emit(item.id); $event.stopPropagation()"
    class="icon"
    [model]="{ type: 'font', value: item.faIcon() }"
  ></u-icon>
</ng-container>
